import NewProduct from './NewProduct'

export default NewProduct



// WEBPACK FOOTER //
// ./src/components/Products/New/index.js